import { render, staticRenderFns } from "./GameNotes.vue?vue&type=template&id=21bf5422&scoped=true&"
import script from "./GameNotes.vue?vue&type=script&lang=js&"
export * from "./GameNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bf5422",
  null
  
)

export default component.exports